import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "./stores/auth.js";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./views/LoginView.vue"),
      meta: { public: true },
    },
    {
      path: "/",
      name: "projects",
      component: () => import("./views/ProjectsView.vue"),
    },
    {
      path: "/projects/:id/graph",
      name: "project-workspace",
      component: () => import("./views/workspace/WorkspaceView.vue"),
      props: true,
      children: [
        {
          path: "",
          name: "workspace-canvas",
          component: () => import("./views/workspace/CanvasView.vue"),
          props: true,
        },
        {
          // Same canvas, with the focused-view POPUP pre-opened for this claim
          // (§16.4 — the focused view is a modal, not a separate page; this
          // route exists purely so other views can deep-link to "canvas with
          // claim X's popup open").
          path: "claim/:claimId",
          name: "workspace-claim",
          component: () => import("./views/workspace/CanvasView.vue"),
          props: true,
        },
        {
          path: "cluster/:clusterId",
          name: "workspace-cluster",
          component: () => import("./views/workspace/ClusterEditor.vue"),
          props: true,
        },
        {
          path: "document",
          name: "workspace-document",
          component: () => import("./views/workspace/DocumentView.vue"),
          props: true,
        },
      ],
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./views/UsersView.vue"),
      meta: { adminOnly: true },
    },
    {
      path: "/account",
      name: "account",
      component: () => import("./views/AccountView.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("./views/NotFoundView.vue"),
    },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.ready) {
    await auth.refresh();
  }

  if (to.meta.public) {
    // Signed-in users don't need the login page again.
    if (to.name === "login" && auth.isAuthenticated) return { name: "projects" };
    return true;
  }

  if (!auth.isAuthenticated) {
    return { name: "login", query: { redirect: to.fullPath } };
  }

  if (to.meta.adminOnly && !auth.isAdmin) {
    return { name: "projects" };
  }

  return true;
});

export default router;
